/** True when the string is an http(s) URL (vs a legacy gradient/variant key). */
export function isHttpUrl(value?: string | null): boolean {
  return !!value && /^https?:\/\//i.test(value);
}
